export default __webpack_public_path__ + "static/media/LAS0360.34I-33178_-18070_0.52afc8ca.jpg";